import React from "react";
import DeliveryTab from "./DeliveryTab";

const SectionTab2 = ({
  invoiceData,
  setInvoiceData,
  theme,
  deliveryTabValue,
  handleChange,
  accountData,
  areaCodes,
}) => {
  return (
    <div className="grid lg:grid-cols-1">
      <DeliveryTab
        theme={theme}
        deliveryTabValue={deliveryTabValue}
        handleChange={handleChange}
        invoiceData={invoiceData}
        setInvoiceData={setInvoiceData}
        accountData={accountData}
        areaCodes={areaCodes}
      />
    </div>
  );
};

export default SectionTab2;
